import { toast } from 'react-toastify'

interface NetworkStatus {
  isOnline: boolean
  message: string
}

export const checkNetworkStatus = (): NetworkStatus => {
  const isOnline = navigator.onLine

  return {
    isOnline,
    message: isOnline ? 'Online' : 'Sem conexão com a internet!',
  }
}

export const handleConnectionError = (): boolean => {
  const networkStatus = checkNetworkStatus()

  if (!networkStatus.isOnline) {
    toast.error(networkStatus.message)
    return true
  }

  return false
}
